import React from "react";
import { Box, Grid, TextField, Tooltip, Autocomplete, Typography, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { tr } from "date-fns/locale";

const EquipmentInfo = (props) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                p: 2,
                backgroundColor: "#f9f9f9",
                borderRadius: 2,
                boxShadow: 3,
                mb: 1,
                mt: 1,
                width: "100%",
                maxWidth: "100%"
            }}
        >
            <Grid container spacing={2} alignItems="center">
                {/* Technician Selection */}
                <Grid item xs={12} sm={3} md={3} padding={1}>
                    <Tooltip title={props.technicianNames?.map((item) => item.userName).join(",\n")}>
                        <Autocomplete
                            multiple
                            options={props.techData}
                            disabled={props.disableStates.isMaintenanceOperatorDisabled}
                            value={props.technicianNames ?? []}
                            limitTags={1}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.userName}
                            renderInput={(params) => (
                                <TextField {...params} label={t("MaintenanceOperator(s)")} error={props.hasTechinicianError} helperText={props.technicianErrorText} variant="outlined" size="small" />
                            )}
                            onChange={(event, newValue) => {
                                props.handleTechnicianChange(newValue);
                            }}
                            renderOption={(_props, option) => <li {..._props}>{option.userName}</li>}
                            fullWidth
                        />
                    </Tooltip>
                </Grid>

                {/* Plant */}
                <Grid item xs={4} sm={2} md={2} padding={1}>
                    <TextField label={t("Plant")} size="small" fullWidth disabled={props.disableStates.isPlantDisable} value={props.plantName} />
                </Grid>

                {/* Main Equipment */}
                <Grid item xs={4} sm={2} md={2} padding={1}>
                    <TextField label={t("MainEquipment")} size="small" fullWidth disabled={props.disableStates.isLineDisable} value={props.mainEquipmentCode} />
                </Grid>

                {/* Equipment */}
                <Grid item xs={4} sm={2} md={2} padding={1}>
                    <TextField label={t("Equipment")} size="small" fullWidth disabled={props.disableStates.isEquipmentDisable} value={props.equipmentName} />
                </Grid>

                {/* Date + EWO Code side-by-side */}
                <Grid item xs={6} sm={2.5} md={1.8} padding={1}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                        <DatePicker
                            label={t("EwoCreatedDate")}
                            value={props.ewoCreatedDate}
                            onChange={props.handleDateChange}
                            disabled={props.disableStates.isDateDisable}
                            inputFormat="dd.MM.yyyy"
                            minDate={new Date()}
                            renderInput={(params) => <TextField {...params} size="small" error={props.hasEwoCreatedDateError} helperText={props.ewoCreatedDateErrorText} fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid xs={6} sm={1.5} md={1.2} padding={1}>
                    <TextField label={t("EwoCode")} size="small" disabled={props.disableStates.isEwoCodeDisable} value={props.ewocode} fullWidth />
                </Grid>
            </Grid>
        </Box>
    );
};

export default EquipmentInfo;
